module.exports = __webpack_public_path__ + "static/media/employee_male.34420bf2.svg";